import 'waypoints/lib/jquery.waypoints';
import Log from './log';

export default class Navigation {
  constructor() {
    // Elements
    this.body = $('body');
    this.navToggle = $('.js-nav_toggle');
    this.navToggleText = this.navToggle.find('.js-nav_toggle-text');

    // Bind
    this.navToggle.on('click', (event) => { this.toggleMobileNav(event); });

    // Run
    this.setupWaypoint();
  }

  toggleMobileNav(event) {
    event.preventDefault();
    this.body.toggleClass('nav_open', '');
    this.navToggleText.text((i, text) => (text === 'Menu' ? 'Close' : 'Menu'));
    Log.track('Mobile Navigation', 'toggled', null);
  }

  shrinkNav(direction) {
    this.body.toggleClass('is-scrolled', '');
    if (direction === 'down') {
      setTimeout(() => {
        this.body.addClass('is-animated');
      }, 350);
      setTimeout(() => {
        this.body.addClass('is-animated-after');
      }, 360);
    }
    if (direction === 'up') {
      this.body.removeClass('is-animated is-animated-after');
    }
  }

  setupWaypoint() {
    const that = this;
    const navWaypoint = new Waypoint({ // eslint-disable-line no-unused-vars
      element: $('.header-placeholder'),
      handler(direction) {
        that.shrinkNav(direction);
      },
      offset: -92,
    });
  }
}
